import { AnyAction } from 'redux';
import { Notification, NotificationActions, NotificationState, NotificationStatus } from './notification-models';


const InitialState: NotificationState =
{
    notifications: null,
    notificationLoaded: false,
};



export const notificationReducer = (state = InitialState, action: AnyAction): NotificationState => {

    switch (action.type) {

        case NotificationActions.SET_NOTIFICATION:
            return {
                ...state,
                notifications: action.payload,
                notificationLoaded: true,
            };

        case NotificationActions.SET_NOTIFCATION_READ:
            if (!state.notifications) return state;
            return {
                ...state,
                notifications: state.notifications.map(n => n.notification_id === action.payload ?  { ...n, notification_status: NotificationStatus.DISMISSED } : n),
            };

        default: return state;
    }
};

const sortByPriority = (a: Notification, b: Notification) => {

    if (a.priority === b.priority) {
        if (a.create_timestamp > b.create_timestamp) {
            return -1;
        }
        if (a.create_timestamp < b.create_timestamp) {
            return 1;
        }
    }
    if (a.priority > b.priority) {
        return -1;
    }
    if (a.priority < b.priority) {
        return 1;
    }
    // a must be equal to b
    return 0;
};

export const setNotifications = (notifications: Notification[]) => {
    const sorted = [...notifications].sort(sortByPriority);
    return {
        type: NotificationActions.SET_NOTIFICATION,
        payload: sorted,
    };
};

export const setNotificationRead = (notificationId: number) => {
    return {
        type: NotificationActions.SET_NOTIFCATION_READ,
        payload: notificationId,
    };
};
